export default __webpack_public_path__ + "static/media/error-404.16b6300f.png";